import { useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger);

export default function Contatti() {
    const container = useRef();

    useGSAP(() => {
        gsap.from('.map-box', {
            scrollTrigger: {
                trigger: '.map-box',
                start: 'top 90%',
                toggleActions: 'play none none none',
                once: true,
            },
            opacity: 0,
            x: -100,
            duration: 1.3,
            ease: 'power2.out',
        });

        gsap.from('.contact-box', {
            scrollTrigger: {
                trigger: '.contact-box',
                start: 'top 90%',
                toggleActions: 'play none none none',
                once: true,
            },
            opacity: 0,
            x: 100,
            duration: 1.3,
            ease: 'power2.out',
        });

        gsap.from('.contact-item', {
            scrollTrigger: {
                trigger: '.contact-box',
                start: 'top 90%',
                toggleActions: 'play none none none',
                once: true,
            },
            opacity: 0,
            y: 40,
            duration: 1,
            ease: 'power1.out',
            stagger: 0.15,
            delay: 0.3,
        });

        gsap.from('.contact-social', {
            scrollTrigger: {
                trigger: '.contact-social',
                start: 'top 95%',
                toggleActions: 'play none none none',
                once: true,
            },
            opacity: 0,
            scale: 0.9,
            duration: 1,
            ease: 'power1.out',
        });
    }, { scope: container });

    return (
        <section id="contatti" ref={container}>
            <div className="flex lg:flex-row flex-col p-8 gap-8">
                <div className="map-box lg:w-1/2 h-100 p-5 bg-[#5b90ab70] rounded-3xl shadow-2xl">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2767.9013310638675!2d9.299280785294412!3d46.07300855704308!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4784153d9f96cdf7%3A0x97b2f358048ee00b!2sLario%20Clima%20Service%20di%20Nordin!5e0!3m2!1sit!2sit!4v1753811524896!5m2!1sit!2sit"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title="Lario Clima Service"
                        className="rounded-3xl"
                    ></iframe>
                </div>
                <div className="contact-box lg:w-1/2 lg:h-100 h-120 p-5 bg-[#5b90ab70] rounded-3xl text-center shadow-2xl">
                    <h1 className="text-white text-4xl font-semibold pt-5">Contatti</h1>
                    <div className="flex lg:flex-row flex-col pt-10 justify-center gap-8">
                        <div className="contact-item bg-[#5b90ab70] rounded-3xl flex flex-row lg:p-6 p-4 items-center lg:gap-2 gap-4 shadow-2xl">
                            <img width="36" height="36" src="https://img.icons8.com/ios-filled/50/ffffff/phone.png" alt="phone"/>
                            <a href="https://wa.me/393203184317" target="_blank" rel="noopener noreferrer">
                                <p className="text-white font-bold lg:text-3xl text-2xl">320 318 4317</p>
                            </a>
                        </div>
                        <div className="contact-item bg-[#5b90ab70] rounded-3xl flex flex-row lg:p-6 p-4 items-center lg:gap-2 gap-4 shadow-2xl">
                            <img width="36" height="36" src="https://img.icons8.com/ios-filled/50/ffffff/mail.png" alt="mail"/>
                            <a href="mailto:nordin93@hotmail.it">
                                <p className="text-white font-bold lg:text-3xl text-2xl">nordin93@hotmail.it</p>
                            </a>
                        </div>
                    </div>
                    <div className="contact-social flex flex-row pt-10 justify-center lg:gap-8 gap-4">
                        <div className="bg-[#5b90ab70] rounded-3xl flex flex-row lg:p-6 p-4 items-center lg:gap-2 gap-4 shadow-2xl lg:w-auto w-full">
                            <img width="36" height="36" src="https://img.icons8.com/?size=100&id=118467&format=png&color=ffffff" alt="mail"/>
                            <a href="https://www.facebook.com/p/Lario-Clima-Service-100095146102465/">
                                <p className="text-white font-bold lg:text-3xl text-2xl">Facebook</p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
